import React, { useContext } from "react"
import { Div, Text } from "atomize"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBaseball } from "@fortawesome/free-solid-svg-icons"
import { theme } from "../settings/config"
import { lessonsContext } from "../providers/lessons.provider"
import Switch from "../atoms/Switch"
import Divider from "../atoms/Divider"

// "Gioco io" (src/utils/match.utils.js): se il "+" chiede ogni volta
// "Lezione o Gioco io?". Chi non gioca lo spegne, e il "+" apre subito la
// lezione come prima. Come la vista e il tema, per questo telefono o questo
// computer.
function MatchesSelector() {
	const { matchesEnabled, setMatchesEnabled } = useContext(lessonsContext)

	return (
		<>
			<Divider w="2px solid" borderColor={theme.colors.background} m={{ y: "1rem" }} />

			<Div
				d="flex"
				align="center"
				justify="space-between"
				cursor="pointer"
				role="switch"
				aria-checked={matchesEnabled}
				aria-label="Gioco io nel +"
				style={{ gap: "0.75rem" }}
				onClick={() => setMatchesEnabled(!matchesEnabled)}>
				<Div d="flex" align="center" style={{ gap: "0.75rem", minWidth: 0 }}>
					<Div
						w="40px"
						h="40px"
						rounded="circle"
						bg={matchesEnabled ? theme.colors.match : theme.colors.gray_light}
						d="flex"
						align="center"
						justify="center"
						transition
						style={{ flexShrink: 0 }}>
						<FontAwesomeIcon
							icon={faBaseball}
							color={matchesEnabled ? theme.colors.match_dark : theme.colors.text_light}
						/>
					</Div>
					<Div style={{ minWidth: 0 }}>
						<Text textWeight="bold" textSize="subheader">
							Gioco io
						</Text>
						<Text textSize="caption" textColor={theme.colors.text_light}>
							{matchesEnabled
								? "Il + chiede se è una lezione o se giochi tu"
								: "Il + apre subito una lezione"}
						</Text>
					</Div>
				</Div>
				<Switch
					shadow="0"
					checked={matchesEnabled}
					activeColor={theme.colors.gunmetal_fill}
					inactiveColor="gray_light"
					style={{ flexShrink: 0 }}
				/>
			</Div>
		</>
	)
}

export default MatchesSelector
